import React, { useLayoutEffect } from 'react';

import styles from './index.scss';

interface Props {
  className?: string;
}

const FullScreenModal: React.FC<Props> = ({ children, className = '' }) => {
  /*
   * Fix scrolling issues
   */
  useLayoutEffect(() => {
    document.body.classList.add(styles.freezeBody);
    document.querySelector('[data-pagelet-container-id=header-navigation]')?.classList.add(styles.hideHeader);
    document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.add(styles.hideFooter);
    return () => {
      document.body.classList.remove(styles.freezeBody);
      document.querySelector('[data-pagelet-container-id=header-navigation]')?.classList.remove(styles.hideHeader);
      document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.remove(styles.hideFooter);
    };
  }, []);

  return <div className={`${styles.fullScreenModal} ${className}`}>{children}</div>;
};

export default FullScreenModal;
